var exports = {
  "D": "x234b8571--58a15b--carousel",
};

module.exports = exports;
